import React, { useState, useEffect } from "react";
import "./HighScoresMode.css";
import SyncIcon from "@mui/icons-material/Sync";
const CACHE_KEY = "highScoresCache";
const CACHE_TIMESTAMP_KEY = "highScoresCacheTimestamp";
const CACHE_DURATION = 30000; // 30 seconds in milliseconds

const HighScoresMode = () => {
  const [highScores, setHighScores] = useState([]);

  const handleRefreshClick = () => {
    const button = document.querySelector(".refresh-scores");
    button.classList.add("spin");
    setHighScores([]);

    // Remove class after animation ends (600ms)
    setTimeout(() => {
      button.classList.remove("spin");
    }, 900);
    setTimeout(() => {
      fetchHighScores();
    }, 500);
  };

  // Function to fetch and cache high scores
  const fetchHighScores = () => {
    fetch("https://www.rikerwilson.com/api/getHighScores", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        setHighScores(data);
        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString());
      })
      .catch((err) =>
        console.error("Error fetching high scores uh:", err, err.message)
      );
  };

  // Manual refresh handler
  const refreshScores = () => {
    // wait 2 seconds before fetching new data
    const button = document.querySelector(".refresh-scores");
    button.classList.add("spin");
    setTimeout(() => {
      button.classList.remove("spin");
    }, 900);
    fetchHighScores();
  };

  useEffect(() => {
    // On mount, check if cached data exists and is fresh
    const cachedData = localStorage.getItem(CACHE_KEY);
    const cacheTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);

    if (cachedData && cacheTimestamp) {
      const age = Date.now() - parseInt(cacheTimestamp, 10);
      if (age < CACHE_DURATION) {
        setHighScores(JSON.parse(cachedData));
      } else {
        // Cache is stale; fetch fresh data
        fetchHighScores();
      }
    } else {
      // No cache available; fetch data
      fetchHighScores();
    }

    // Set up an interval to refresh the high scores every 30 seconds
    const intervalId = setInterval(() => {
      refreshScores();
    }, CACHE_DURATION);

    // Clean up the interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Function to assign rank emojis
  const getRankEmoji = (rank) => {
    if (rank === 1) return "👑";
    if (rank === 2) return "🥈";
    if (rank === 3) return "🥉";
    return "";
  };

  return (
    <div className="highscores-container">
      <div className="highscores-header">
        <h2>Global High Scores</h2>
        <button className="refresh-scores" onClick={handleRefreshClick}>
          <SyncIcon fontSize="large" />
        </button>
      </div>
      <div className="refresh-scores-container"></div>
      <div className="highscores-table-wrapper">
        <table className="highscores-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Name</th>
              <th>Score</th>
              <th>Avg. Time Difference</th>
              <th>Attempts</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {highScores.length > 0 ? (
              highScores.map((player, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "even-row" : "odd-row"}
                >
                  <td>
                    {index + 1} {getRankEmoji(index + 1)}
                  </td>
                  <td>{player.name}</td>
                  <td>{player.score}</td>
                  <td>{player.avgDifference} mins</td>
                  <td>{player.attempts}</td>
                  <td>{player.date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-data">
                  No scores available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HighScoresMode;